import { WORK_ORDER_SUBSTATUSES } from "@miplatform/constants";
import { MiTHEME } from "@miplatform/theme";
import {
  IAttempt,
  IAttemptListItemResponseForWorkOrder,
  IWorkOrderInfo,
  WorkOrderStatus,
} from "@miplatform/types";
import { Theme } from "@mui/material";

export const getWorkOrderStatus = (
  attempt: IAttemptListItemResponseForWorkOrder | IAttempt
) => {
  const { assignment, previousStatus } = attempt;
  const { workOrder } = assignment ?? {};

  if (previousStatus === WorkOrderStatus.Hold) {
    return WorkOrderStatus.HoldPreviousDay;
  }

  return workOrder?.status || WorkOrderStatus.New;
};

export const getWorkOrderSubstatus = (workOrder: IWorkOrderInfo) => {
  if (workOrder.status === WorkOrderStatus.Complete) {
    return WORK_ORDER_SUBSTATUSES.COMPLETE;
  }

  if (workOrder?.isLate) {
    return WORK_ORDER_SUBSTATUSES.LATE;
  }

  if (workOrder?.isAtRisk) {
    return WORK_ORDER_SUBSTATUSES.AT_RISK;
  }

  return workOrder.status as WorkOrderStatus;
};

export const getWorkOrderDueDateColor = (
  attempt: IAttemptListItemResponseForWorkOrder | IAttempt,
  theme: Theme = MiTHEME as unknown as Theme
) => {
  const { assignment: { workOrder } = {} } = attempt;

  if (workOrder?.isLate) {
    return theme.palette.error.main;
  }

  if (workOrder?.isAtRisk) {
    return theme.palette.warning.main;
  }

  return theme.palette.grey.darkAccent;
};
